export default function isPresent(x) {
    return x !== undefined && x !== null;
};
